import { Check } from "lucide-react";

export function StageTimeline({ stages = [], current }) {
  // "Completed" is the old name of the final "Closed" stage (kept on older cases)
  const cur = !stages.includes(current) && current === "Completed" && stages.includes("Closed") ? "Closed" : current;
  const idx = Math.max(0, stages.indexOf(cur));
  const pct = stages.length > 1 ? Math.round((idx / (stages.length - 1)) * 100) : 0;
  return (
    <div data-testid="stage-timeline">
      <div className="flex items-center justify-between mb-3">
        <span className="text-sm font-semibold text-slate-700">Progress</span>
        <span className="text-sm font-bold text-primary">{pct}%</span>
      </div>
      <div className="h-2 bg-slate-100 rounded-full overflow-hidden mb-6">
        <div className="h-full bg-primary rounded-full transition-all duration-700" style={{ width: `${pct}%` }} />
      </div>
      <ol className="space-y-0">
        {stages.map((s, i) => {
          const done = i < idx;
          const active = i === idx;
          return (
            <li key={s} className="flex gap-3 relative pb-4 last:pb-0">
              {i < stages.length - 1 && <span className={`absolute left-[13px] top-7 bottom-0 w-0.5 ${done ? "bg-primary" : "bg-slate-200"}`} />}
              <div className={`relative z-10 h-7 w-7 rounded-full flex items-center justify-center shrink-0 text-xs font-bold ${done ? "bg-primary text-white" : active ? "bg-primary/10 text-primary ring-2 ring-primary" : "bg-slate-100 text-slate-400"}`}>
                {done ? <Check className="h-4 w-4" /> : i + 1}
              </div>
              <div className="pt-0.5">
                <div className={`text-sm font-medium ${active ? "text-primary" : done ? "text-slate-700" : "text-slate-400"}`}>{s}</div>
                {active && <div className="text-xs text-slate-400">Current stage</div>}
              </div>
            </li>
          );
        })}
      </ol>
    </div>
  );
}
